import PropTypes from "prop-types"
import React, { Component } from "react"

import Autosuggest from "react-autosuggest"

// We combine the styles of the InputField with custom styles for the autosuggest
import filterStyles from "./DepartmentSelectorFilterInput.module.scss"
import inputFieldStyles from "./InputField.module.sass"

const parseCoordinates = (obj) => ({
  ...obj,
  latitude: parseFloat(obj.latitude),
  longitude: parseFloat(obj.longitude),
})

class PostalCode extends Component {
  static propTypes = {
    doneCallback: PropTypes.func,
    postcodesForTypeaheadUrl: PropTypes.string,
    labels: PropTypes.object,
    options: PropTypes.array,
    onCapturePostCode: PropTypes.func,
    isSellYourCar: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.requestTimeout = undefined
    this.state = {
      suggestions: [],
      suggestedSelected: false,
      filterValue: "",
      allOptionsToggled: false,
      error: undefined,
    }
  }

  _getSuggestionValue = (suggestion) => suggestion.value

  _onSuggestionsFetchRequested = ({ value }) => {
    if (this.requestTimeout) {
      clearTimeout(this.requestTimeout)
    }

    this.requestTimeout = setTimeout(() => {
      fetch(
        `${this.props.postcodesForTypeaheadUrl}?query=${encodeURIComponent(
          value
        )}`,
        {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
        }
      )
        .then((res) => res.json()) // TODO: Handle failure when res status is not 200
        .then((data) => {
          // Same on me for mutating props. I had to do it in order to compare on validations,
          // if the selected value is one of the options
          this.props.options.splice(
            0,
            this.props.options.length,
            ...data.map(parseCoordinates)
          )
          this.setState({
            suggestions: this.props.options,
            error:
              data.length === 0
                ? this.props.labels.validationMessages.postalCodeCity
                : undefined,
          })
        })
    }, 500)
  }

  _onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  _onSuggestionSelected = (_event, { suggestion }) => {
    this.props.doneCallback(suggestion)
  }

  _filterValueChanged = (_event, { newValue }) => {
    this.setState((prevState) => {
      const newState = { filterValue: newValue }
      return newState
    })
  }

  _renderSuggestion = (suggestion) => <div>{suggestion.name}</div>

  _toggleAllOptions = () => {
    this.setState((prevState) => ({
      allOptionsToggled: !prevState.allOptionsToggled,
    }))
  }

  render() {
    const inputProps = {
      placeholder: this.props.labels.placeholders.departmentFilter,
      value: this.state.filterValue,
      onChange: this._filterValueChanged,
      autoFocus: true,
    }

    return (
      <>
        <Autosuggest
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this._onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this._onSuggestionsClearRequested}
          onSuggestionSelected={this._onSuggestionSelected}
          getSuggestionValue={this._getSuggestionValue}
          renderSuggestion={this._renderSuggestion}
          inputProps={inputProps}
          highlightFirstSuggestion
          theme={{
            ...filterStyles,
            input: "unstyled " + inputFieldStyles.input,
            container:
              filterStyles.container +
              " " +
              inputFieldStyles.inputContainer +
              " " +
              inputFieldStyles.searchContainer,
          }}
        />
        {this.props.isSellYourCar &&
          this.state.error &&
          this.state.filterValue && <p className="error">{this.state.error}</p>}
      </>
    )
  }
}

export default PostalCode
